<template>
  <v-layout v-if="horizontal" row justify-space-between>
    <menu-h-link to="/dashboard" text="Dashboard" :icon="dashboardIcon" style="margin-left: -10px;"/>
    <menu-h-link to="/application-networks" text="Application Networks" :icon="applicationNetworksIcon" />
    <menu-h-link to="/gateways" text="Gateways" :icon="gatewaysIcon" />
    <menu-h-link to="/end-devices" text="End-devices" :icon="endDevicesIcon" />
    <menu-h-link to="/people" text="People" :icon="peopleIcon" />
    <menu-h-link to="/me" text="Me" :icon="myAccountIcon" />

    <slot v-if="!$mq.md_sm" />
    <template v-else>
      <menu-h-link to="/operations" text="Operations" :icon="operationsIcon" />
      <menu-h-link to="/support" text="Support" :icon="supportIcon" />
      <menu-h-link to="/logout" text="Log Out" :icon="logOutIcon" exact />
    </template>
  </v-layout>

  <v-list v-else-if="vertical && group === '1'" class="pt-0" >
    <menu-v-link to="/dashboard" text="Dashboard" :icon="dashboardIcon" />
    <menu-v-link to="/application-networks" text="Application Networks" :icon="applicationNetworksIcon" />
    <menu-v-link v-if="$route.path.includes('application-networks')" to="/application-networks/profiles" text="Profiles" subMenu />
    <menu-v-link to="/gateways" text="Gateways" :icon="gatewaysIcon" />
    <menu-v-link to="/end-devices" text="End-devices" :icon="endDevicesIcon" />
    <menu-v-link v-if="$route.path.includes('end-devices')" to="/end-devices/profiles" text="Profiles" subMenu />
    <menu-v-link v-if="$route.path.includes('end-devices')" to="/end-devices/groups" text="Groups" subMenu />
    <menu-v-link to="/policies" text="Policies" :icon="policiesIcon" />
    <menu-v-link to="/operations" text="Operations" :icon="operationsIcon" />
    <menu-v-link to="/people" text="People" :icon="peopleIcon" />
    <menu-v-link :to="{ path: '/service_api_keys' }" text="Service Api Keys" :icon="keyIcon" />
  </v-list>

  <v-list v-else-if="vertical && group === '2'" class="pt-0">
    <menu-v-link to="/me" text="Me" :icon="myAccountIcon" />
    <menu-v-link v-if="sysAdmin || orgAdmin" :to="currentUserOrganizationPath" text="Organization" :icon="orgIcon" />
    <menu-v-link v-if="sysAdmin || sysRo" to="/organizations" text="Organizations" :icon="orgsIcon" />
    <menu-v-link to="/support" text="Support" :icon="supportIcon" />
    <menu-v-link to="/logout" text="Log Out" :icon="logOutIcon" exact />
  </v-list>
</template>


<script>
/* @flow */
import icons from '../icons'
import {orgAdmin, sysAdmin, sysRo} from '@/utils/api'

const MenuHLink = {
  props: ['icon', 'text', 'to', 'exact'],
  template: `
    <router-link
      :to="to"
      class="menu-h-link flex flex-none flex-column items-center black-text text-decoration-none"
      :exact="exact"
      style="padding: 8px; margin: -8px;"
    >
      <v-icon >{{icon}}</v-icon>
      <span v-if="$mq.md_sm">{{text}}</span>
    </router-link>
  `,
  created() {
    if (process.env.NODE_ENV === 'test') {
      this.$mq = this.$parent.$mq
    }
  },
}

const MenuVLink = {
  props: {
    icon: String,
    text: String,
    to: String,
    exact: Boolean,
    subMenu: Boolean,
  },
  template: `
  <v-list-tile :to="to" class="menu-v-link" :class="{subMenu: subMenu}" :exact="exact">
      <v-list-tile-action>
        <v-icon>{{icon}}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
      <v-list-tile-title class="menu-v-title" >
          {{text}}
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  `,
}

export default {
  extends: {
    computed: {
      sysAdmin,
      orgAdmin,
    },
  },
  name: 'MenuList',
  props: {
    horizontal: Boolean,
    vertical: {
      type: Boolean,
      default: true,
    },
    group: String,
  },
  data() {
    return {
      ...icons,
    }
  },
  computed: {
    currentUserOrganizationPath() {
      return `/my_organization/${this.$store.getters.currentOrganization.id}`
    },
  },
  components: {
    MenuVLink,
    MenuHLink,
  },
}
</script>


<style>
.menu-h-link.router-link-active span {
  color: #0072ce;
}
.menu-h-link.router-link-active .icon {
  color: #0072ce;
}

.menu-v-link > .list__tile {
  padding-left: 14px;
}
.menu-v-link.subMenu > .list__tile {
  height: 40px;
}

.list > .menu-v-link > .list__tile--active .icon {
}
.list > .menu-v-link > .list__tile--active .list__tile__title {
}

.navigation-drawer > .list .list__tile--active {
  color: #0072ce;
  background-color: #ecedef;
  border-right: 1px solid #dee1e3;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/MenuList.vue